"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'axelar',
    client_id: '07-tendermint-109',
    connection_id: 'connection-96'
  },
  chain_2: {
    chain_name: 'sommelier',
    client_id: '07-tendermint-13',
    connection_id: 'connection-10'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-72',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics-20',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'injective',
    client_id: '07-tendermint-135',
    connection_id: 'connection-108'
  },
  chain_2: {
    chain_name: 'sommelier',
    client_id: '07-tendermint-4',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-93',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'kujira',
    client_id: '07-tendermint-107',
    connection_id: 'connection-77'
  },
  chain_2: {
    chain_name: 'sommelier',
    client_id: '07-tendermint-12',
    connection_id: 'connection-8'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-69',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {}
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1745',
    connection_id: 'connection-1348'
  },
  chain_2: {
    chain_name: 'sommelier',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-165',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'sommelier',
    client_id: '07-tendermint-60',
    connection_id: 'connection-75'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-131',
    connection_id: 'connection-122'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-71',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-150',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;